export const fontFamily = `'Noto Sans JP', 'Roboto', sans-serif`

export const fontWeightExtraLight = 100
export const fontWeightLight = 300
export const fontWeightRegular = 400
export const fontWeightMedium = 500
// HACK: Noto Sans JP には font-weight: 600 が存在しないので 700 のfontになっている
export const fontWeightSemiBold = 600
export const fontWeightBold = 700
